import { setDefaults as r } from "./index47.mjs";
var e = {
  type: "3rdParty",
  init: function(t) {
    r(t.options.react);
  }
};
export {
  e as initReactI18next
};
